import React from "react";
import { Offcanvas } from "react-bootstrap";
import {
  MdVisibility,
  MdEmail,
  MdPhone,
  MdLocationOn,
  MdDescription,
  MdCalendarToday,
} from "react-icons/md";

const AlmataOemDetailsOffcanvas = ({
  show,
  onHide,
  partner,
}) => {
  return (
    <Offcanvas show={show} onHide={onHide} placement="end" style={{ width: "500px" }}>
      <Offcanvas.Header className="border-bottom">
        <Offcanvas.Title className="d-flex align-items-center">
          <MdVisibility className="me-2 text-primary" />
          OEM Partner Details
        </Offcanvas.Title>
        <button
          type="button"
          className="btn-close"
          onClick={onHide}
          aria-label="Close"
        />
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {partner && (
          <>
            <div className="bg-light p-3 border-bottom">
              <div className="d-flex align-items-center">
                {partner.logo && (
                  <img
                    src={partner.logo}
                    alt="Company Logo"
                    className="rounded me-3"
                    style={{
                      height: "60px",
                      objectFit: "cover",
                      border: "1px solid #ddd",
                    }}
                  />
                )}
                <div>
                  <h6 className="mb-0">{partner.companyName}</h6>
                  <span
                    className={`badge ${
                      partner.status === "active" ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {partner.status?.toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-3 border-bottom">
              <h6 className="text-muted mb-3">Contact Information</h6>
              <div className="row g-1">
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <MdEmail className="text-muted me-2" style={{ fontSize: "12px" }} />
                    <span>{partner.email}</span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <span className="text-muted me-2" style={{ fontSize: "10px" }}>
                      👤
                    </span>
                    <span>
                      {partner.firstName} {partner.lastName}
                    </span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <MdPhone className="text-muted me-2" style={{ fontSize: "12px" }} />
                    <span>
                      {partner.countryCode
                        ? `(${partner.countryCode}) ${partner.contactNumber}`
                        : partner.contactNumber}
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <MdLocationOn className="text-muted me-2" style={{ fontSize: "14px" }} />
                    <span>
                      {partner.country} ({partner.currency})
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {partner.planDetails && partner.planDetails.length > 0 && (
              <div className="p-3 border-bottom">
                <h6 className="text-muted mb-3">Plan Details</h6>
                {partner.planDetails.map((plan, index) => (
                  <div key={index} className="card mb-2">
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h6 className="card-title mb-0">{plan.planName}</h6>
                        <span className="badge bg-primary">
                          {plan.currency} {plan.amount / 100}
                        </span>
                      </div>
                      <small className="text-muted">Product ID: {plan.stripeProductId}</small>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="p-3 border-bottom">
              <h6 className="text-muted mb-3">
                <MdDescription className="me-2" />
                Almata Shared Description
              </h6>
              <p className="mb-0">
                {partner.almataSharedDiscription || "No description available"}
              </p>
            </div>
            <div className="p-3">
              <h6 className="text-muted mb-3">
                <MdCalendarToday className="me-2" />
                Timeline
              </h6>
              <div className="row g-2">
                <div className="col-12">
                  <small className="text-muted">Created At</small>
                  <div>
                    {new Date(partner.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>
                <div className="col-12">
                  <small className="text-muted">Last Updated</small>
                  <div>
                    {new Date(partner.updatedAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AlmataOemDetailsOffcanvas;